import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import { I18nProvider } from './utils/i18n';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import StockDetailPage from './pages/StockDetailPage';
import RecommendationsPage from './pages/RecommendationsPage';
import DayTraderPage from './pages/DayTraderPage';
import Layout from './components/Layout';
import RootRedirect from './components/landing/RootRedirect';

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/" element={<RootRedirect />} />
          <Route path="/dashboard" element={<Layout />}>
            <Route index element={<DayTraderPage />} />
          </Route>
          <Route path="/" element={<Layout />}>
            <Route path="stock" element={<StockDetailPage />} />
            <Route path="recommendations" element={<RecommendationsPage />} />
          </Route>
          {/* Old trading routes folded into the unified Day Trader page */}
          <Route path="/daytrader" element={<Navigate to="/dashboard" replace />} />
          <Route path="/cn-daytrader" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </I18nProvider>
    </ThemeProvider>
  );
}
